module.exports = __webpack_public_path__ + "static/end-cover-cb64a74ad8f69be8c1ad17dfcb13327d.png";